module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f4fbf5b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Logout.vue
// module id = 633
// module chunks = 1